import { Spinner } from "@components/ui-kit";
import { NotFoundExpense } from "@components/widgets/ErrorPage";
import { useExpenseForCreateExpenseQuery } from "@src/__generated__/graphql";
import {
  LockDocumentTypeEnum,
  UnlockDocumentDocument,
  type UnlockDocumentMutation,
  type UnlockDocumentMutationVariables,
} from "@src/__generated__/urql-graphql";
import { client } from "@src/services/client";
import { onError } from "@src/utils/apollo";
import { useStore } from "@src/utils/hooks";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Create } from "../Create";
import { Store, StoreContext } from "../store";

interface EditModuleProps {
  id: string;
}

async function handleBackClick(document_id: string) {
  await client
    .mutation<UnlockDocumentMutation, UnlockDocumentMutationVariables>(
      UnlockDocumentDocument,
      {
        document_id: document_id,
        document_type: LockDocumentTypeEnum.Expense,
      },
    )
    .toPromise();
}

export const EditModule = observer<EditModuleProps>(function EditModule({
  id,
}) {
  const appStore = useStore();
  const [store] = useState(() => new Store(appStore, FormMode.EDIT));

  const { data, loading } = useExpenseForCreateExpenseQuery({
    variables: { id },
    skip: !id,
    onCompleted(data) {
      store.setExpense(data.expense);
      appStore.UIStore.onBackButtonClick = async () => {
        if (store.isDocumentLockedByMe) {
          handleBackClick(id);
        }
      };
    },
    ...onError(),
  });

  if (loading) {
    return <Spinner absolute />;
  }

  if (!data?.expense) {
    return <NotFoundExpense />;
  }

  return (
    <StoreContext.Provider value={store}>
      <Create />
    </StoreContext.Provider>
  );
});
